export class Model {
  private id!: number;
  private pulseCost!: number;
  private valueMax!: number;
  private name!: string;

  public getId(): number {
    return this.id || -1;
  }

  public getName(): string {
    return this.name || '';
  }

  public getPulseCost(): number {
    return this.pulseCost;
  }

  public getValueMax(): number {
    return this.valueMax;
  }
}
